import { api } from '../../../app/auth/apiSlice';

export interface Chat {
  id: number;
  sender: string;
  msg_contents: any;
  msg_contents_json: any;
}

export interface ChatHistory {
  results: Chat[];
}

const chatbotApi = api
  .enhanceEndpoints({ addTagTypes: ['Chat'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getChatHistory: builder.query<any, any>({
        query: (offset: any) => {
          return `v1/chatbot/messages/?limit=10&offset=${offset}`;
        },
        providesTags: ['Chat'],
      }),
    }),
  });

export const { useGetChatHistoryQuery } = chatbotApi;
